import React, { useEffect, useState } from "react";
import { AppBar, Box, Button, Modal, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import axios from "axios";

import { StepFive, StepForm, StepFour, StepOne, StepSix, StepThree, StepTwo } from "./components/Steps";
import './style.css';
import Loading from "../components/Loading";
import ModalSuccess from "../components/ModalSuccess";
import { RemoverMascara } from "../../utils/RemoverMascara";
import AlertSuccess from "../components/AlertSuccess";
import AlertError from "../components/AlertError";


export default function Cart() {

    const [perguntas, setPerguntas] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/buscar/perguntas/all`);
                console.log("Dados recebidos:", response.data);
                setPerguntas(response.data);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            }
        };
        fetchData();
    }, [])

    const options = [
        {
            id: "conteudo",
            title: "Apenas conteúdo",
            description: "Acesso completo ao conteúdo.",
            price: "R$ 50,00"
        },
        {
            id: "conteudo_consultoria",
            title: "Conteúdo + Consultoria",
            description: "Acesso ao conteúdo + 30 minutos com um consultor.",
            price: "R$ 165,00"
        }
    ];

    const [steps, setSteps] = useState(localStorage.getItem("steps") ? JSON.parse(localStorage.getItem("steps")) : [
        "Formulário",
        "E-mail",
        "Confirmar e-mail",
        "Opção de compra",
        "Forma de pagamento",
        "Pagamento"
    ]);

    const navigate = useNavigate();

    const [step, setStep] = useState(localStorage.getItem("stepAtual") ? parseInt(localStorage.getItem("stepAtual")) : 0);
    const [selected, setSelected] = useState(localStorage.getItem("selectedOption") || "");
    const [email, setEmail] = useState(localStorage.getItem("emailForm") || "");
    const [codigoVerificacao, setCodigoVerificacao] = useState("");
    const [tipoPagamento, setTipoPagamento] = useState("CARTAO");
    const [showBack, setShowBack] = useState(false);
    const [cardErrors, setCardErrors] = useState({});
    const [cardData, setCardData] = useState({ name: "", number: "", expiry: "", cvv: "" });
    const [modeloNegocio, setModeloNegocio] = useState("");
    const [respostas, setRespostas] = useState(localStorage.getItem("respostas") ? JSON.parse(localStorage.getItem("respostas")) : {});
    const [encodedImage, setEncodedImage] = useState("");
    const [payload, setPayload] = useState("");
    const [cpf, setCpf] = useState(localStorage.getItem("cpf") || "");
    const [nome, setNome] = useState(localStorage.getItem("nome") || "");
    const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
    const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
    const [openAlertError, setOpenAlertError] = useState(false);
    const [mensagem, setMensagem] = useState("");

    useEffect(() => {
        if (step === 5 && tipoPagamento === "PIX") {
            console.log(tipoPagamento)
            const interval = setInterval(async () => {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/obterStatusPagamento`, { params: { email, idCobrancaAsaas: localStorage.getItem("idCobrancaAsaas") } });
                console.log("Resposta da validação de pagamento:", response.data);
                if (response.data.status === "PAGO") {
                    setModalSuccessOpen(true);
                    localStorage.removeItem("stepAtual");
                    localStorage.removeItem("nome");
                    localStorage.removeItem("cpf");
                    localStorage.removeItem("emailForm");
                    localStorage.removeItem("respostas");
                    localStorage.removeItem("steps");
                    clearInterval(interval);
                }
            }, 5000);

            // Limpeza do intervalo quando o componente desmontar
            return () => clearInterval(interval);
        }
    }, []);

    const handleFinishOrder = async () => {
        let errors = { valid: true };

        if (tipoPagamento === "PIX") {
            try {
                setOpen(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/gerarPix`, { email, selectedOption: selected, cpf: RemoverMascara(cpf), nome });
                console.log("Resposta do pedido PIX:", response.data);
                if (response.data.status === 200) {
                    localStorage.setItem("idCobrancaAsaas", response.data.idCobrancaAsaas);
                    console.log(response.data.data);
                    setEncodedImage(response.data.data.encodedImage);
                    setPayload(response.data.data.payload);
                    setStep(step + 1);

                    // alert("Pedido realizado com sucesso! Você receberá um e-mail com as instruções para pagamento via PIX.");
                    // localStorage.removeItem("stepAtual");
                    // localStorage.removeItem("emailForm");
                    // localStorage.removeItem("respostas");
                    // localStorage.removeItem("steps");
                }
            } catch (error) {
                console.error("Erro ao processar pedido via PIX:", error);
                setMensagem("Ocorreu um erro ao processar seu pedido. Por favor, tente novamente.");
                setOpenAlertError(true);
            } finally {
                setOpen(false);
            }
        }

        if (tipoPagamento === "CARTAO") {
            // setStep(step + 1);
            errors = validateCardData(cardData);
            setCardErrors(errors);
            if (errors.valid) {
                try {
                    setOpen(true);
                    cardData.cpf = RemoverMascara(cpf);
                    cardData.number = RemoverMascara(cardData.number);
                    cardData.telefone = RemoverMascara(cardData.telefone);
                    cardData.cep = RemoverMascara(cardData.cep);
                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/pagamentoCartao`, { email, selectedOption: selected, cpf, nome, cardData });
                    if (response.data.status === 200) {
                        console.log(response.data);
                        if (selected === "conteudo_consultoria") {
                            setStep(step + 1);
                        } else {
                            localStorage.removeItem("idCobrancaAsaas");
                            localStorage.removeItem("emailForm");
                            localStorage.removeItem("cpf");
                            localStorage.removeItem("nome");
                            localStorage.removeItem("respostas");
                            localStorage.removeItem("selectedOption");
                            localStorage.removeItem("stepAtual");
                            localStorage.removeItem("steps");
                            setModalSuccessOpen(true);
                        }
                    }
                } catch (error) {
                    console.error("Erro ao processar pagamento com cartão:", error);
                    setMensagem("Ocorreu um erro ao processar seu pagamento. Por favor, tente novamente.");
                    setOpenAlertError(true);
                } finally {
                    setOpen(false);
                }
            }
        }
    }

    const handleSendVerificationCode = async () => {
        try {
            setOpen(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/enviarCodigo`, { email });
            console.log("Código de verificação enviado para o e-mail:", response.data);
            if (response.data.status === 400) {
                setMensagem("E-mail já cadastrado.");
                setOpenAlertSuccess(true);
                return 3
            } else {
                setMensagem("Código de verificação enviado para o seu e-mail. Por favor, verifique sua caixa de entrada.");
                setOpenAlertSuccess(true);
                return 2;
            }
        } catch (error) {
            console.error("Erro ao enviar código de verificação:", error);
            setMensagem("Ocorreu um erro ao enviar o código de verificação. Por favor, tente novamente.");
            setOpenAlertError(true);
            return 2;
        } finally {
            setOpen(false);
        }
    }

    const handleVerifyCode = async () => {
        try {
            setOpen(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/verificarCodigo`, { email, codigo: codigoVerificacao });
            console.log("Resposta da verificação:", response.data);
            if (response.data.status === 200) {
                setMensagem("Código verificado com sucesso!");
                setOpenAlertSuccess(true);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error("Erro ao verificar código de verificação:", error);
            setMensagem("Código de verificação inválido. Por favor, tente novamente.");
            setOpenAlertError(true);
            return false;
        } finally {
            setOpen(false);
        }
    }

    const handleSaveInformacoes = async () => {
        try {
            setOpen(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/salvarInformacoes`, { email, respostas, cpf: RemoverMascara(cpf), nome });
            return response.data.status === 200;
        } catch (error) {
            console.error("Erro ao salvar informações:", error);
            return false;
        } finally {
            setOpen(false);
        }
    }

    const handleNext = async () => {
        if (step === 0) {
            if (!respostas[perguntas[0]?.pergunta] || !respostas[perguntas[1]?.pergunta] || !respostas[perguntas[2]?.pergunta] || !respostas[perguntas[3]?.pergunta] || !respostas[perguntas[4]?.pergunta] || !respostas[perguntas[5]?.pergunta] || !respostas[perguntas[6]?.pergunta] || !respostas[perguntas[7]?.pergunta] || !respostas[perguntas[8]?.pergunta] || !respostas[perguntas[9]?.pergunta] || !respostas[perguntas[10]?.pergunta] || !respostas[perguntas[11]?.pergunta] || (respostas[perguntas[11]?.pergunta] === "Sim" && (!respostas[perguntas[12]?.pergunta] || !respostas[perguntas[13]?.pergunta])) || !respostas[perguntas[14]?.pergunta] || !respostas[perguntas[15]?.pergunta] || !respostas[perguntas[16]?.pergunta] || !respostas[perguntas[17]?.pergunta] || !respostas[perguntas[18]?.pergunta] || !respostas[perguntas[19]?.pergunta] || (respostas[perguntas[19]?.pergunta] === "Sim" && (!respostas[perguntas[20]?.pergunta] || !respostas[perguntas[21]?.pergunta]))) {
                setMensagem("Por favor, responda todas as perguntas para continuar.");
                setOpenAlertError(true);
                return;
            }
            if (respostas[perguntas[2]?.pergunta] === "Outro" && !modeloNegocio) {
                setMensagem("Por favor, informe o modelo de negócio para continuar.");
                setOpenAlertError(true);
                return;
            }

            for (let i in respostas) {
                if (i === "Modelo de negócio?" && respostas[i] === "Outro") {
                    respostas[i] = modeloNegocio;
                }
            }
            localStorage.setItem("respostas", JSON.stringify(respostas));
            console.log("Respostas do formulário:", respostas);
            localStorage.setItem("stepAtual", step + 1);
            setStep(step + 1);
            return;
        }

        if (step === 1) {
            if (!email) {
                setMensagem("Por favor, informe seu e-mail para continuar.");
                setOpenAlertError(true);
                return;
            }
            if (!/\S+@\S+\.\S+/.test(email)) {
                setMensagem("Por favor, informe um e-mail válido para continuar.");
                setOpenAlertError(true);
                return;
            }
            if (!cpf) {
                setMensagem("Por favor, informe seu CPF para continuar.");
                setOpenAlertError(true);
                return;
            }
            if (!nome) {
                setMensagem("Por favor, informe seu nome para continuar.");
                setOpenAlertError(true);
                return;
            }
            const result = await handleSendVerificationCode();
            setStep(result);
            localStorage.setItem("stepAtual", result);
            localStorage.setItem("emailForm", email);
            localStorage.setItem("nome", nome);
            localStorage.setItem("cpf", cpf);
            return;
        }

        if (step === 2) {
            if (!codigoVerificacao) {
                setMensagem("Por favor, informe o código de verificação para continuar.");
                setOpenAlertError(true);
                return;
            }
            const isVerified = await handleVerifyCode();
            if (!isVerified) {
                return;
            }

            const isSaved = await handleSaveInformacoes();
            if (!isSaved) {
                setMensagem("Ocorreu um erro ao salvar suas informações. Por favor, tente novamente.");
                setOpenAlertError(true);
                return;
            }
            localStorage.setItem("stepAtual", step + 1);
            setStep(step + 1);
        }

        if (step === 3) {
            if (!selected) {
                setMensagem("Por favor, escolha uma opção para continuar.");
                setOpenAlertError(true);
                return;
            }

            if (selected === "conteudo_consultoria") {
                if (!steps.includes("Agende sua consultoria")) {
                    setSteps([...steps, "Agende sua consultoria"]);
                    localStorage.setItem("steps", JSON.stringify([...steps, "Agende sua consultoria"]));
                }
            } else {
                if (steps.includes("Agende sua consultoria")) {
                    setSteps(steps.filter(s => s !== "Agende sua consultoria"));
                    localStorage.setItem("steps", JSON.stringify(steps.filter(s => s !== "Agende sua consultoria")));
                }
            }
            localStorage.setItem("selectedOption", selected);
            localStorage.setItem("stepAtual", step + 1);
            setStep(step + 1);
        }

        if (step === 4) {
            if (!tipoPagamento) {
                setMensagem("Por favor, escolha uma forma de pagamento para continuar.");
                setOpenAlertError(true);
                return;
            }
            if (tipoPagamento === "PIX") {
                console.log("Processando pagamento via PIX...");
                await handleFinishOrder();
            }
            localStorage.setItem("stepAtual", step + 1);
            setStep(step + 1);
        }
    }

    const validateCardData = (data) => {
        const errors = { valid: true };

        // Nome no cartão (mínimo 3 caracteres, apenas letras e espaços)
        if (!data.name.trim()) {
            errors.name = "O nome no cartão é obrigatório";
            errors.valid = false;
        } else if (!/^[a-zA-ZÀ-ÿ\s]{3,}$/.test(data.name)) {
            errors.name = "Nome inválido";
            errors.valid = false;
        }

        // Número do cartão (somente números, entre 13 e 19 dígitos)
        const cleanNumber = data.number.replace(/\s+/g, "");
        if (!cleanNumber) {
            errors.number = "O número do cartão é obrigatório";
            errors.valid = false;
        } else if (!/^\d{13,19}$/.test(cleanNumber)) {
            errors.number = "Número de cartão inválido";
            errors.valid = false;
        }

        // Validade (MM/YYYY)
        if (!data.expiry) {
            errors.expiry = "A data de validade é obrigatória";
            errors.valid = false;
        } else if (!/^(0[1-9]|1[0-2])\/\d{4}$/.test(data.expiry)) {
            errors.expiry = "Formato inválido (MM/AAAA)";
            errors.valid = false;
        } else {
            const [month, year] = data.expiry.split("/");
            const now = new Date();
            const expiryDate = new Date(year, month); // mês/ano do cartão
            if (expiryDate < now) {
                errors.expiry = "Cartão vencido";
                errors.valid = false;
            }
        }

        // CVV (3 ou 4 dígitos)
        if (!data.cvv) {
            errors.cvv = "O CVV é obrigatório";
            errors.valid = false;
        } else if (!/^\d{3,4}$/.test(data.cvv)) {
            errors.cvv = "CVV inválido";
            errors.valid = false;
        }

        if (!data.cpf) {
            errors.cpf = "O CPF é obrigatório";
            errors.valid = false;
        } else if (!/^\d{11}$/.test(data.cpf.replace(/\D/g, ""))) {
            errors.cpf = "CPF inválido";
            errors.valid = false;
        }

        if (!data.telefone) {
            errors.telefone = "O telefone é obrigatório";
            errors.valid = false;
        } else if (!/^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/.test(data.telefone)) {
            errors.telefone = "Telefone inválido";
            errors.valid = false;
        }

        if (!data.cep) {
            errors.cep = "O CEP é obrigatório";
            errors.valid = false;
        } else if (!/^\d{5}-?\d{3}$/.test(data.cep)) {
            errors.cep = "CEP inválido";
            errors.valid = false;
        }

        if (!data.numeroResidencia) {
            errors.numeroResidencia = "O número de residência é obrigatório";
            errors.valid = false;
        } else if (!/^\d+$/.test(data.numeroResidencia)) {
            errors.numeroResidencia = "Número de residência inválido";
            errors.valid = false;
        }

        return errors;
    };


    return (
        <>
            {/* HEADER */}
            <AppBar position="sticky" sx={{ backgroundColor: "#000000de" }} elevation={1}>
                <Toolbar sx={{ justifyContent: "space-between" }}>
                    <Box onClick={() => navigate("/")} sx={{ cursor: "pointer" }}>
                        <img src="/assets/Logo_Contblack_FundoEscuro.png" alt="Logo" />
                    </Box>

                    <Box>
                        <Button variant="contained" size="small" sx={{ backgroundColor: "#1EFF86", color: "black" }}>Diagnóstico</Button>
                    </Box>
                </Toolbar>
            </AppBar>

            <section style={{ width: "100%", height: "fit-content", display: "flex", justifyContent: "center", gap: "20px", marginTop: "20px", marginBottom: "40px" }} >
                <div style={{ width: window.innerWidth < 600 ? "95%" : "1000px", height: "fit-content", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", backgroundColor: "#ffffff", display: "flex", flexDirection: "column", padding: "20px", boxSizing: "border-box" }} >

                    {step === 0 && <StepForm
                        modeloNegocio={modeloNegocio}
                        setModeloNegocio={setModeloNegocio}
                        perguntas={perguntas}
                        respostas={respostas}
                        setRespostas={setRespostas}
                    />}
                    {step === 1 && <StepOne nome={nome} setNome={setNome} email={email} setEmail={setEmail} cpf={cpf} setCpf={setCpf} />}
                    {step === 2 && <StepTwo email={email} codigoVerificacao={codigoVerificacao} setCodigoVerificacao={setCodigoVerificacao} />}
                    {step === 3 && <StepThree options={options} selected={selected} setSelected={setSelected} />}
                    {(step === 4 || step === 5) && <StepFour selected={selected} tipoPagamento={tipoPagamento} setTipoPagamento={setTipoPagamento} step={step} />}
                    <div style={{ width: "100%", display: step === 5 || step === 6 ? "none" : "flex", justifyContent: step === 0 ? "flex-end" : "center", marginTop: "20px", flexWrap: "wrap", gap: "10px" }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "transparent",
                                border: "1px solid #1EFF86",
                                display: step === 0 ? "none" : "block",
                                color: "black",
                                marginTop: "20px",
                                "&:hover": {
                                    backgroundColor: "#1EFF86",
                                    color: "black",
                                },
                            }}
                            onClick={() => { setStep(step - 1); localStorage.setItem("stepAtual", step - 1); }}
                        >
                            {step === 2 ? "voltar para e-mail" : "Voltar"}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#1EFF86",
                                color: "black",
                                marginTop: "20px",
                                "&:hover": {
                                    backgroundColor: "#1EFF86",
                                    color: "black",
                                },
                            }}
                            onClick={handleNext}
                        >
                            {step === 2 ? "verificar código" : step === 4 ? "Ir para pagamento" : "Próximo"}
                        </Button>
                    </div>
                    {step === 5 && <StepFive tipoPagamento={tipoPagamento} showBack={showBack} setShowBack={setShowBack} cardData={cardData} setCardData={setCardData} cardErrors={cardErrors} setCardErrors={setCardErrors} encodedImage={encodedImage} payload={payload} />}
                    {step === 6 && <StepSix />}
                    <div style={{ width: "100%", display: step !== 5 ? "none" : "flex", justifyContent: "center", marginTop: "20px", gap: "10px" }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "transparent",
                                border: "1px solid #1EFF86",
                                display: step === 0 ? "none" : "block",
                                color: "black",
                                marginTop: "20px",
                                "&:hover": {
                                    backgroundColor: "#1EFF86",
                                    color: "black",
                                },
                            }}
                            onClick={() => { setStep(step - 1); localStorage.setItem("stepAtual", step - 1); }}
                        >
                            Mudar forma de pagamento
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#1EFF86",
                                color: "black",
                                marginTop: "20px",
                                display: tipoPagamento === "PIX" ? "none" : "block",
                                "&:hover": {
                                    backgroundColor: "#1EFF86",
                                    color: "black",
                                },
                            }}
                            onClick={handleFinishOrder}
                        >
                            Realizar pagamento
                        </Button>
                    </div>
                </div>
                <div
                    style={{
                        width: "240px",
                        height: "fit-content",
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        border: "1px solid #eee",
                        display: window.innerWidth < 600 ? "none" : "block",
                    }}
                >
                    <h2 style={{ marginBottom: "20px" }}>Etapas</h2>

                    {steps.map((s, index) => (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "10px",
                                borderRadius: "8px",
                                transition: "0.2s",
                                cursor: "pointer",
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#f5f5f5")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                            }
                        >
                            <CheckCircleOutlineIcon style={{ color: index < step ? "#4caf50" : "#ccc" }} />
                            <span>{s}</span>
                        </div>
                    ))}
                </div>
            </section>
            <Loading open={open} />
            <ModalSuccess open={modalSuccessOpen} setOpen={setModalSuccessOpen} />
            <AlertSuccess openAlertSuccess={openAlertSuccess} setOpenAlertSuccess={setOpenAlertSuccess} mensagem={mensagem} />
            <AlertError openAlertError={openAlertError} setOpenAlertError={setOpenAlertError} mensagem={mensagem} />
        </>
    );
}